const STORAGE_KEY = 'postLoginRedirectUrl';

export function setPostLoginRedirect(url: string): void {
    localStorage.setItem(STORAGE_KEY, url);
}

export function getPostLoginRedirect(): string | null {
    return localStorage.getItem(STORAGE_KEY);
}

export function clearPostLoginRedirect(): void {
    localStorage.removeItem(STORAGE_KEY);
}
